import React from 'react';
import style from '../css/More.module.css';
import { Link } from 'react-router-dom';

function MoreBtn({ toLink, icon, text }) {
	return (
		<Link to={toLink} className={style.MoreBtn}>
			{icon}
			<p className={style.btnstyle}>{text}</p>
		</Link>
	);
}

export default MoreBtn;
